<nav class="breadcrumb-bar" [attr.aria-label]="'breadcrumbBar.ariaLabel' | translate">
  <div class="breadcrumb-bar__content">

    <!-- Back arrow -->
    <button *ngIf="showBack"
            type="button"
            class="breadcrumb-bar__back"
            [attr.aria-label]="'common.back' | translate"
            (click)="back.emit()">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M3.50625 8.25L8.63958 13.3833L7.33333 14.6667L0 7.33333L7.33333 0L8.63958 1.28333L3.50625 6.41667H14.6667V8.25H3.50625Z"
              fill="currentColor"/>
      </svg>
    </button>

    <!-- Home icon -->
    <button *ngIf="showHome"
            type="button"
            class="breadcrumb-bar__home"
            [attr.aria-label]="'breadcrumbBar.home' | translate"
            (click)="home.emit()">
      <svg width="21" height="22" viewBox="0 0 21 22" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 0.5L0.500015 10.2371H2.77131V20.8891H8.48109V14.6535H12.7082V20.8891H18.3549V10.2371H20.5L10.5 0.5Z"
              stroke="currentColor" stroke-linejoin="round" fill="none"/>
      </svg>
    </button>

    <!-- ===== Multi-segment breadcrumb (preferred path) ===== -->
    <ng-container *ngIf="hasSegments">
      <ng-container *ngFor="let segment of segments; let i = index; let last = last">

        <!-- Chevron separator between every pair of segments -->
        <span class="breadcrumb-bar__sep" aria-hidden="true">
          <svg width="7" height="11" viewBox="0 0 7 11" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 1 L6 5.5 L1.5 10"
                  stroke="currentColor" stroke-width="2"
                  stroke-linecap="square" stroke-linejoin="miter"
                  fill="none"/>
          </svg>
        </span>

        <!-- A real `href` keeps Ctrl/Cmd/middle-click "open in new tab" working; a
             plain left-click is intercepted by `onSegmentClick` and delegated to the
             host's `navigate` output, which goes BACK in history when the crumb is
             already behind the current page (so returning up the trail never leaves
             the just-exited page in the back stack) instead of pushing a new entry.
             NOT a plain `routerLink`: that always PUSHES, which caused the breadcrumb
             back-loop bug. -->
        <a *ngIf="segment.link; else current"
           class="breadcrumb-bar__segment breadcrumb-bar__segment--link"
           [href]="hrefFor(segment)"
           [title]="segment.label"
           (click)="onSegmentClick($event, segment)">
          {{ segment.label }}
        </a>
        <ng-template #current>
          <span class="breadcrumb-bar__segment breadcrumb-bar__segment--current"
                [attr.aria-current]="last ? 'page' : null"
                [title]="segment.label">
            {{ segment.label }}
          </span>
        </ng-template>

      </ng-container>
    </ng-container>

    <!-- ===== Single-label fallback (legacy) ===== -->
    <ng-container *ngIf="!hasSegments">
      <span class="breadcrumb-bar__sep" aria-hidden="true">
        <svg width="7" height="11" viewBox="0 0 7 11" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1 L6 5.5 L1.5 10"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="square" stroke-linejoin="miter"
                fill="none"/>
        </svg>
      </span>
      <span class="breadcrumb-bar__label">{{ label }}</span>
    </ng-container>

  </div>

  <!-- Trailing chrome projected by the host (e.g. AppComponent's term-scope selector,
       2026-08-19 ADR D1) — sits at the row's right edge, outside the scrollable
       content region. -->
  <ng-content select="[bcTrailing]"></ng-content>
</nav>
